/* ============================================================
   GYAANSTORE — CART CROSS-TAB HEARTBEAT  (assets/gs-cart-heartbeat.js)
   Loaded ONCE site-wide in layout/theme.liquid (defer).

   THE PROBLEM (plain language):
   Each browser TAB is isolated. If you change the cart in one tab — e.g. remove an
   item on the /cart page, or add from a collection page — other open tabs (a product
   page, the header cart count) don't hear about it and stay stale until a refresh.

   THE TRICK:
   Browsers share `localStorage` across tabs of the SAME site, and writing to it fires
   a `storage` event in the OTHER tabs (never in the tab that wrote it). So we use one
   localStorage key, 'ss-cart-ts', as a shared "heartbeat":
     • When THIS tab's cart changes  -> we write a fresh timestamp (the heartbeat).
     • When ANOTHER tab's heartbeat arrives -> we refresh this tab's header cart count.
   The product buy box already listens for 'ss-cart-ts' and re-syncs itself, so between
   the two, the header count AND the product page stay in sync across every open tab.
   ============================================================ */
(function () {
  var KEY = 'ss-cart-ts';

  /* ---- 1) Send a heartbeat whenever THIS tab's cart changes ---- */
  function beat() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  // Dawn publishes its `cartUpdate` event from pubsub.js, which is loaded `defer`
  // (so it may not exist yet while this runs). Attach once it's available.
  var subDone = false;
  function attachPubSub() {
    if (subDone) return true;
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, beat);
        subDone = true;
        return true;
      }
    } catch (e) {}
    return false;
  }
  if (!attachPubSub()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachPubSub);
    var tries = 0;
    var iv = setInterval(function () { if (attachPubSub() || ++tries > 50) clearInterval(iv); }, 100);
  }
  // Our custom cart events fire from quick-add / Frequently-Bought-Together / the buy box.
  document.addEventListener('cart:updated', beat);
  document.addEventListener('cart:refresh', beat);

  /* ---- 2) Receive another tab's heartbeat -> refresh this tab's header count ---- */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refreshHeaderCount();
  });

  // Re-render just the header cart-count bubble using Shopify's Section Rendering API
  // (same section Dawn itself re-renders on a cart change). Cheap and surgical.
  function refreshHeaderCount() {
    var dest = document.getElementById('cart-icon-bubble');
    if (!dest) return;
    fetch(window.location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector('.shopify-section') || parsed.body;
        if (source) dest.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }
})();
